import { useTheme, AHText, Box, AHInput } from "arkh";
import { useIntl } from "react-intl";
import { useMutation } from "react-relay";
import { graphql } from "relay-runtime";
import { AlertButtons } from "../../../../common/Alert";
import { WebPopup } from "../../../../common/WebPopup";
import { useIntlTokens } from "../../../../components/mobile/useIntlTokens";
import { TemplateSelectorUpdateTemplatePopupMutation } from "./__generated__/TemplateSelectorUpdateTemplatePopupMutation.graphql";
import { useState } from "react";

export function TemplateSelectorUpdateTemplatePopup(props: {
  todoWorkspaceId: string;
  onDismiss: () => void;
  template: null | {
    id: string;
    name: string;
  };
}) {
  return (
    <WebPopup onDismiss={props.onDismiss}>
      {props.template === null ? null : (
        <Content
          template={props.template}
          todoWorkspaceId={props.todoWorkspaceId}
          onDismiss={props.onDismiss}
        />
      )}
    </WebPopup>
  );
}

function Content(props: {
  onDismiss: () => void;
  todoWorkspaceId: string;
  template: {
    id: string;
    name: string;
  };
}) {
  const intl = useIntl();
  const intl_tokens = useIntlTokens();
  const theme = useTheme();

  const [name, setName] = useState<string>(props.template.name);
  const [updateTemplate] =
    useMutation<TemplateSelectorUpdateTemplatePopupMutation>(graphql`
      mutation TemplateSelectorUpdateTemplatePopupMutation(
        $templateId: ID!
        $todoWorkspaceId: ID!
        $name: String
      ) {
        todoWorkspaceTemplate(id: $templateId) {
          updateTemplateFromWorkspaceTodo(
            id: $todoWorkspaceId
            setName: $name
          ) {
            name
            id
          }
        }
      }
    `);

  return (
    <>
      <AHText type="title">{intl_tokens.UpdateTemplate}</AHText>
      <AHText type="body" spaceVertical="medium">
        {intl.formatMessage(
          {
            defaultMessage:
              "Do you want to update {templateName} with current changes?",
            description: "Workspace Todo Edit Replace Template Body",
          },
          {
            templateName: props.template.name,
          }
        )}
      </AHText>
      <Box spaceVertical="medium" spaceBottom="large">
        <AHText type="subtitle" spaceBottom="small">
          {intl_tokens.Name}
        </AHText>
        <AHInput
          style={{ backgroundColor: theme.background }}
          defaultStyle
          onChangeText={setName}
          value={name}
        />
      </Box>
      <AlertButtons
        onPressedButton={props.onDismiss}
        buttons={[
          {
            text: intl_tokens.Cancel,
            style: "cancel",
          },
          {
            text: intl_tokens.Update,
            style: "default",
            onPress: () => {
              updateTemplate({
                variables: {
                  name: name,
                  templateId: props.template.id,
                  todoWorkspaceId: props.todoWorkspaceId,
                },
              });
            },
          },
        ]}
      />
    </>
  );
}
